import { createLayer } from 'src/lib/leafletUtils.js'

function indexOfLayerToRefresh (context, layer, name) {
  for (let i = 0; i < context.rootState.map.layers.overlays.length; i++) {
    if (
      context.rootState.map.layers.overlays[i].layer === layer &&
      context.rootState.map.layers.overlays[i].name === name
    ) {
      return i
    }
  }
  return -1
}

export async function refreshLayer (context, { layer, layerParams }) {
  const index = indexOfLayerToRefresh(context, layer, layerParams.name)
  if (index !== -1) {
    const newLayer = await createLayer(layerParams)
    context.rootState.map.layers.overlays[index].layer.remove()
    context.rootState.map.layers.overlays[index].layer = newLayer
    if (context.rootState.map.layers.overlays[index].visible) {
      context.rootState.map.layers._overlaysGroup.addLayer(newLayer)
    }
    setTimeout(() => context.dispatch('refreshLayer', { layer: newLayer, layerParams }), layerParams.minutesNextRefresh * 60 * 1000)
  }
}
